import { render, staticRenderFns } from "./CampusParttime.vue?vue&type=template&id=260ed431&scoped=true&"
import script from "./CampusParttime.vue?vue&type=script&lang=js&"
export * from "./CampusParttime.vue?vue&type=script&lang=js&"
import style0 from "./CampusParttime.vue?vue&type=style&index=0&id=260ed431&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260ed431",
  null
  
)

export default component.exports